import React, { useState } from "react";
import { Link, useNavigate, NavLink, useParams, useLocation } from "react-router-dom";
import SearchIcon from "../../assets/images/icons/search.svg";
import hamburger from '../../assets/images/icons/hamburger.svg';
import * as actions from '../../redux/actions/billing';
import { logout } from '../../redux/actions/auth';
import { useDispatch, useSelector } from "react-redux";
import { PricingPlanModal } from '../PricingPlanModal';
import { useNavigation } from "../../context/NavigationContext";
import NotificationCenter from '../NotificationCenter';
import { LayoutDashboardIcon, MessageCircleQuestionMarkIcon } from "lucide-react";
import { ReactComponent as ProfessorUIcon } from '../../assets/images/icons/professor.svg';

export const AdminHeader = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { goBack, goForward, canGoBack, canGoForward } = useNavigation();
    const [showDropdown, setShowDropdown] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPricingPlanModal, setShowPricingPlanModal] = useState(false);
    const artistDetails = useSelector(state => state.artistDetails);
    const artistInfo = artistDetails?.artistInfo || {};
    const { hasActiveSubscription } = useSelector((state) => state.billing);

    const handleProClick = async () => {
        try {
            setLoading(true);
            if (hasActiveSubscription) {
                await dispatch(actions.getCustomerPortalSession());
            } else {
                setShowPricingPlanModal(true);
            }
        } catch (err) {
            console.error('Error handling Pro button:', err);
        } finally {
            setLoading(false);
        }
    };

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    const toggleAdminSidebar = () => {
        document.body.classList.toggle('admin-sidebar-open');
    };

    const doSignout = () => {
        dispatch(logout());
        navigate('/');
    };

    return (
        <>
            <header className="sticky top-0 left-0 w-full z-40" data-tour="header">
                <nav className="bg-theme_clr1 py-3 xl:py-4">
                    <div className="container max-w-full">

                        <div className="flex flex-wrap items-center justify-between md:justify-end gap-6 xl:gap-8 transition-transform transform">

                            <div className="md:hidden bg-theme_clr1 flex items-center justify-between">
                                <Link to={"/"}><img src={require("../../assets/images/logo.png")} alt="Logo" className="max-w-[120px]" /></Link>
                            </div>

                            <div className="hidden md:flex items-center gap-2">
                                <button
                                    onClick={goBack}
                                    disabled={!canGoBack}
                                    className={`p-2 rounded-lg transition-colors ${canGoBack ? 'hover:bg-white/10 text-white' : 'text-white/30 cursor-not-allowed'
                                        }`}
                                    title="Go Back"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>
                                <button
                                    onClick={goForward}
                                    disabled={!canGoForward}
                                    className={`p-2 rounded-lg transition-colors ${canGoForward ? 'hover:bg-white/10 text-white' : 'text-white/30 cursor-not-allowed'
                                        }`}
                                    title="Go Forward"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>
                            <div className="menu-wrapper hidden md:block" data-tour="header-navigation">
                                <ul className="list-none flex flex-wrap items-center gap-5 xl:gap-[36px]">
                                    <li>
                                        {location.pathname !== "/dashboard" &&
                                            <Link
                                                to={"/dashboard"}
                                                className="flex items-center gap-2 text-sm text-white font-medium capitalize transition-all"
                                            >
                                                <LayoutDashboardIcon className="w-4 h-4 text-white transition-all" />
                                                Dashboard
                                            </Link>
                                        }
                                    </li>

                                    {/* <li>
                                        <Link
                                            to={"/admin/professor-u"}
                                            className="flex items-center gap-2 text-sm text-white font-medium capitalize transition-all"
                                        >
                                            <ProfessorUIcon className="w-4 h-4 fill-white transition-all" />
                                            ProfessorU
                                        </Link>
                                    </li> */}

                                    <li>
                                        <Link
                                            to={"/"}
                                            state={{ scrollToBottom: true }}
                                            className="flex items-center gap-2 text-sm text-white font-medium capitalize transition-all"
                                        >
                                            <MessageCircleQuestionMarkIcon className="w-4 h-4 text-white transition-all" />
                                            Support
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            {/* <div className="menu-wrapper hidden md:block" data-tour="header-navigation">
                                <ul className="list-none flex flex-wrap items-center gap-5 xl:gap-[36px]">
                                    <li className="flex items-center gap-2">
                                        <LayoutDashboardIcon className="w-4 h-4 text-white hover:text-theme_clr2" />
                                        <Link
                                            to={"/dashboard"}
                                            className="text-sm text-white hover:text-theme_clr2 font-medium inline-block capitalize transition-all"
                                        >
                                            Dashboard
                                        </Link>
                                    </li>

                                    <li className="flex items-center gap-2">
                                        <ProfessorUIcon className="w-4 h-4 text-white hover:text-theme_clr2" />
                                        <Link
                                            to={"/professor-u"}
                                            className="text-sm text-white hover:text-theme_clr2 font-medium inline-block capitalize transition-all"
                                        >
                                            ProfessorU
                                        </Link>
                                    </li>

                                    <li className="flex items-center gap-2">
                                        <MessageCircleQuestionMarkIcon className="w-4 h-4 text-white hover:text-theme_clr2" />
                                        <Link
                                            to={"/"}
                                            state={{ scrollToBottom: true }}
                                            className="text-sm text-white hover:text-theme_clr2 font-medium inline-block capitalize transition-all"
                                        >
                                            Support
                                        </Link>
                                    </li>
                                </ul>
                            </div> */}

                            <div className="flex flex-wrap items-center gap-3 lg:gap-6 xl:gap-8">
                                <div className="hidden md:block search-box relative">
                                    <span className="icon absolute start-[16px] top-1/2 transform -translate-y-1/2 z-1">
                                        <img src={SearchIcon} alt="Search Icon" className="block" />
                                    </span>
                                    <input type="search" className="h-[40px] w-[160px] bg-white text-base ps-[45px] pe-4 py-2 text-black placeholder:text-black focus:outline-none rounded-[12px]" placeholder="Search" />
                                </div>

                                <NotificationCenter />

                                <div className="relative inline-block text-left" data-tour="header-profile">
                                    <button type="button" className="align-middle" aria-expanded={showDropdown} aria-haspopup="true" onClick={toggleDropdown}>
                                        <img src={artistInfo?.avatar || require("../../assets/images/karan.png")} alt="User" className="h-[40px] w-[40px] block rounded-full object-cover" />
                                    </button>
                                    {showDropdown && (
                                        <div className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                                            <div className="py-1" role="none">
                                                <Link
                                                    to="/admin/teams"
                                                    onClick={() => setShowDropdown(false)}
                                                    className="block px-4 py-2 text-sm text-gray-700"
                                                    role="menuitem"
                                                    tabIndex="-1"
                                                >
                                                    Teams
                                                </Link>
                                                <button disabled={loading} onClick={handleProClick} className="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabIndex="-1">
                                                    Billing settings
                                                </button>
                                                <Link to={"/"} state={{ scrollToBottom: true }} className="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabIndex="-1">Support</Link>
                                                <button onClick={doSignout} type="button" className="block w-full px-4 py-2 text-left text-sm text-gray-700" role="menuitem" tabIndex="-1">Sign out</button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <button type="button" className="h-[40px] min-w-[56px] lg:hidden flex items-center justify-center border border-orange rounded-full ms-auto px-5 py-3" onClick={toggleAdminSidebar}>
                                    <img src={hamburger} alt="Mobile Menu" className="icon" />
                                </button>
                            </div>
                        </div>

                        <div className="md:hidden flex flex-col gap-3 mt-3 w-full">
                            {/* Links */}
                            <ul className="list-none flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
                                <li className="flex items-center gap-1.5 min-w-0">
                                    <Link
                                        to={"/dashboard"}
                                        className="flex items-center gap-2 text-sm text-white font-medium capitalize transition-all"
                                    >
                                        <LayoutDashboardIcon className="w-4 h-4 text-white transition-all" />
                                        Dashboard
                                    </Link>
                                </li>

                                {/* <li className="flex items-center gap-1.5 min-w-0">
                                    <Link
                                        to={"/admin/professor-u"}
                                        className="flex items-center gap-2 text-sm text-white font-medium capitalize transition-all"
                                    >
                                        <ProfessorUIcon className="w-4 h-4 text-white transition-all" />
                                        ProfessorU
                                    </Link>
                                </li> */}

                                <li className="flex items-center gap-1.5 min-w-0">
                                    <Link
                                        to={"/"}
                                        state={{ scrollToBottom: true }}
                                        className="flex items-center gap-2 text-sm text-white font-medium capitalize transition-all"
                                    >
                                        <MessageCircleQuestionMarkIcon className="w-4 h-4 text-white transition-all" />
                                        Support
                                    </Link>
                                </li>
                            </ul>

                            {/* Search */}
                            <div className="search-box relative w-full">
                                <span className="absolute left-4 top-1/2 -translate-y-1/2 z-[1]">
                                    <img src={SearchIcon} alt="Search Icon" className="w-4 h-4 block" />
                                </span>

                                <input
                                    type="search"
                                    className="h-[42px] w-full bg-white text-sm ps-[42px] pe-4 py-2 text-black placeholder:text-gray-500 focus:outline-none rounded-xl"
                                    placeholder="Search"
                                />
                            </div>
                        </div>

                    </div>
                </nav>
            </header>
            <PricingPlanModal isOpen={showPricingPlanModal} onClose={() => setShowPricingPlanModal(false)} returnUrl={window.location.origin + "/dashboard"} />
        </>
    );
};